/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Manages fields, a replacement for JSON Schema.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "number",
    title: "Number",
    description: "A field representing a numeric value with optional min, max, and step.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    fields: {
        min: {
            title: "Minimum Value",
            type: "number"
        },
        max: {
            title: "Maximum Value",
            type: "number"
        },
        step: {
            title: "Step Value",
            type: "number"
        }
    },
    tests: {
        valid: {
            must: true,
            run: function () {
                return validate({ title: "Age", type: "number", min: 1, max: 100 }, 42);
            }
        },
        tooSmall: {
            throw: "fields.number.tooSmall",
            run: function () {
                return validate({ title: "Age", type: "number", min: 10 }, 5);
            }
        },
        tooBig: {
            throw: "fields.number.tooBig",
            run: function () {
                return validate({ title: "Age", type: "number", max: 50 }, 55);
            }
        },
        invalidStep: {
            throw: "fields.number.invalidStep",
            run: function () {
                return validate({ title: "Increment", type: "number", step: 5 }, 3);
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Number",
            description: "The value must be a number.",
            template: "Expected number but received ${typeof}"
        },
        tooSmall: {
            title: "Too Small",
            description: "The number is below the minimum value.",
            template: "Minimum is ${min}, got ${value}"
        },
        tooBig: {
            title: "Too Big",
            description: "The number is above the maximum value.",
            template: "Maximum is ${max}, got ${value}"
        },
        invalidStep: {
            title: "Invalid Step",
            description: "The number does not conform to the step value.",
            template: "Value ${value} not valid with step ${step}"
        }
    }
});

function validate(spec, value) {
    if (typeof value !== "number") {
        _.errors.invalid.throw({ typeof: typeof value });
    }

    if ("min" in spec && value < spec.min) {
        _.errors.tooSmall.throw({ min: spec.min, value: value });
    }

    if ("max" in spec && value > spec.max) {
        _.errors.tooBig.throw({ max: spec.max, value: value });
    }

    if ("step" in spec && (value % spec.step !== 0)) {
        _.errors.invalidStep.throw({ step: spec.step, value: value });
    }
}
module.exports.validate = validate;
